import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { getCookie } from '../utils/get-cookie';


interface CreateFormResponse {
  success: boolean;
  data: {
    id: number;
    created_at: Date | null;
    updated_at: Date | null;
    studies_id: number;
    is_completed: number | null;
  };
}
@Injectable({
  providedIn: 'root',
})
export class FormsService {
  
  token: string = '';

  constructor(public httpClient: HttpClient) {
    this.token = getCookie('token');
  }

  getForm(studyId: number): Observable<any> {
    return this.httpClient.get(
      `${environment.api_guia}studies/${studyId}/forms`,
      {
        headers: {
          Authorization: 'Bearer ' + this.token,
        },
      }
    );
  }

  createForms(studyId: number): Observable<CreateFormResponse> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${this.token}`,
    });

    return this.httpClient.post<CreateFormResponse>(
      `${environment.api_guia}forms/${studyId}`,
      {},
      { headers }
    );
  }
}
